let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c9112")).then(() => parcelRequire('d6jO2'));